import { Button, Grid, Stack, TextField, Typography } from "@mui/material";
import React from "react";
import Iconify from "../../../components/Iconify";
import FrmAgregarCobro from "./Forms/FrmAgregarCobros";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useFormik } from "formik";
const MovimientosListHead = ({
  setOpenDialog,
  setBodyDialog,
  setTitle,
  setErrorGraph,
  setOpenSnackBar,
  setMoth,
  mes
}) => {
  const formik = useFormik({
    initialValues: {
      fechaInicio: "",
    },
    onSubmit: async (inputData) => {
    
      setMoth(inputData.fechaInicio)
    },
  });
  const handleOpenDialog = () => {
    setTitle("Registrar un nuevo cobro");

    setBodyDialog(
      <FrmAgregarCobro
        setOpenDialog={setOpenDialog}
        setErrorGraph={setErrorGraph}
        setOpenSnackBar={setOpenSnackBar}
        mes={mes}
      />
    );
    setOpenDialog(true);
  };
  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={5}
      >
        <Typography variant="h4" gutterBottom>
          Ingresos y Cobros
        </Typography>
        <Button
          onClick={() => handleOpenDialog()}
          startIcon={<Iconify icon="eva:plus-fill" />}
        >
          Nuevo Registro
        </Button>
      </Stack>
      <Grid item xs={4} md={4} lg={4}>
        <form onSubmit={formik.handleSubmit}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              views={["month", "year"]}
              onChange={(date) => formik.setFieldValue("fechaInicio", date)}
              value={formik.values.fechaInicio}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="fechaInicio"
                  fullWidth
                  variant="standard"
                  label="Fecha de Inicio"
                />
              )}
            />
          </LocalizationProvider>
          <Stack direction="row" alignItems="center" sx={{ my: 2 }}>
            <Button type="submit">Buscar</Button>
          </Stack>
        </form>
      </Grid>
    </>
  );
};

export default MovimientosListHead;
